import { Button, CancelButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { useSyncNestedDialogState } from 'shared/widgets/CommissionsTabs/context/CommissionsNestedDialogsContext';

type Props = {
  onConfirm: () => void;
  isLoading?: boolean;
} & DialogProps;

export const CommissionsTaskLaunchDialog: React.FC<Props> = ({
  onClose,
  isLoading,
  onConfirm,
  ...props
}) => {
  useSyncNestedDialogState(Boolean(props.open));

  return (
    <Dialog
      {...props}
      maxWidth="lg"
      onClose={onClose}
      sx={{ '& .MuiPaper-root': { width: '640px' } }}
    >
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Подтвердить запрос на запуск перерасчёта?"
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>
            После подтверждения система начнет перерасчёт комиссий по заказам в соответствии с новой
            настройкой. Эта комиссия будет использоваться по умолчанию при создании новых заказов.
          </Typography>
          <br />
          <Typography>
            По завершении перерасчёт система отправит уведомление в корпоративный мессенджер Reddy.
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" onClick={onClose} variant="outlined" />,
            <Button
              isLoading={isLoading}
              key="apply-button"
              label="Подтвердить"
              onClick={onConfirm}
              variant="contained"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
